module.exports = __webpack_public_path__ + "static/media/tel-icon.2df9d155.svg";